/** @format */

import * as React from "react";

import { Button, Intent, ITagProps, MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, MultiSelect } from "@blueprintjs/select";

import { FunctionType, IItem } from "app/types";

import "app/utils/select-overrides.css"; // overriding z-index, mainly

const INTENTS = [
    Intent.NONE,
    Intent.PRIMARY,
    Intent.SUCCESS,
    Intent.DANGER,
    Intent.WARNING,
];

interface IProps {
    items: IItem[];
    currentSelections: IItem[];
    selectItemFn: FunctionType;
    deSelectItemFn: FunctionType;
    deSelectAllItemsFn: FunctionType;
    placeholder?: string;
    labelMap?: {
        [key: string]: string;
    };
}

// const ItemMultiSelect = MultiSelect.ofType<IItem>();

interface IState {
    items: IItem[];
    intent: boolean;
    resetOnSelect: boolean;
    tagMinimal: boolean;
}

// need props to override state and set the initial items (originators, etc.)
// should keep the same shape to the data, though, so no need to send different functions down
export default class MplMultiSelect extends React.PureComponent<IProps> {
    public state: IState = {
        intent: true,
        items: [],
        resetOnSelect: true,
        tagMinimal: false,
    };

    constructor(props: IProps) {
        super(props);
        this.state.items = this.props.currentSelections;
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.currentSelections !== this.props.currentSelections) {
            this.setState({
                items: this.props.currentSelections,
            });
        }
    }

    public renderItem: ItemRenderer<IItem> = (
        item,
        { modifiers, handleClick }
    ) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const { labelMap } = this.props;
        const itemText =
            item.furtherInfo !== undefined && item.furtherInfo !== null
                ? `${item.name} (${item.furtherInfo})`
                : `${item.name}`;

        return (
            <MenuItem
                active={modifiers.active}
                icon={this.isItemSelected(item) ? "tick" : "blank"}
                key={item.id}
                onClick={handleClick}
                text={itemText}
                label={labelMap && labelMap[item.id] ? labelMap[item.id] : ""}
                shouldDismissPopover={false}
            />
        );
    };

    public handleClick = (item: IItem): void => {
        // required, but not active in MultiSelect
    };

    public render() {
        // const clearButton =
        //     this.state.items && this.state.items.length > 0 ? (
        //         <Button icon="cross" minimal={true} onClick={this.handleClear} />
        //     ) : null;
        const clearButton =
            this.state.items && this.state.items.length > 0 ? (
                <Button
                    icon="cross"
                    minimal={true}
                    onClick={this.handleClear}
                />
            ) : undefined;

        return (
            <div>
                <MultiSelect
                    items={this.props.items}
                    resetOnSelect={this.state.resetOnSelect}
                    itemRenderer={this.renderItem}
                    noResults={<MenuItem disabled={true} text="No results." />}
                    tagRenderer={this.renderTag}
                    onItemSelect={this.handleItemSelect}
                    selectedItems={this.state.items}
                    itemPredicate={this.filterItem}
                    // prettier-ignore
                    // @ts-ignore
                    tagInputProps={{ tagProps: this.getTagProps,
                        onChange: this.handleOnChange,
                        onInputChange: this.handleOnChange,
                        // @ts-ignore
                        onRemove: this.handleTagRemove,
                        rightElement: clearButton,
                    }}
                    popoverProps={{ minimal: false }}
                    placeholder={this.props.placeholder || "Search ..."}
                />
            </div>
        );
    }

    private getTagProps = (_value: string, index: number): ITagProps => ({
        intent: this.state.intent
            ? INTENTS[index % INTENTS.length]
            : Intent.NONE,
        minimal: this.state.tagMinimal,
    });

    private handleTagRemove = (_tag: string, index: number) => {
        this.deselectItem(index);
    };

    private handleClear = () => {
        this.setState({ items: [] });
        this.props.deSelectAllItemsFn();
    };

    private renderTag = (item: IItem) => item.name;

    private filterItem: ItemPredicate<IItem> = (query, item) => {
        return (
            `${item.id}. ${item.name.toLowerCase()}`.indexOf(
                query.toLowerCase()
            ) >= 0
        );
    };

    private getSelectedItemIndex(item: IItem) {
        return this.state.items.indexOf(item);
    }

    private isItemSelected(item: IItem) {
        return this.getSelectedItemIndex(item) !== -1;
    }
    private selectItem(item: IItem) {
        this.props.selectItemFn(item);
        this.setState({ items: [...this.state.items, item] });
    }
    private deselectItem(index: number) {
        this.props.deSelectItemFn(this.state.items[index]);
        this.setState({
            items: this.state.items.filter((el, i) => i !== index),
        });
    }
    private handleItemSelect = (item: IItem) => {
        if (!this.isItemSelected(item)) {
            this.selectItem(item);
        } else {
            this.deselectItem(this.getSelectedItemIndex(item));
        }
    };

    private handleOnChange = () => {
        // no action needed
    };
}
